export const ID_ROLE_OPERATOR = 'operator';
export const ID_ROLE_TEAM_LEADER = 'lead';
export const ID_ROLE_ADMIN = 'admin';
